const BASIC_OPT_IN_GATE_BODY =
  'Big Property Management would like to send you SMS messages from our new system.  Reply with YES or START to opt-in.';

const DEFAULT_OPT_IN_GATE_BODY =
  'Big Property Management: We would like to send you text messages from our new system for maintenance request updates, important notices for your property like utility outages or inspections, and information about your account.  We suggest saving this as "Big Property Management SMS" as a contact. You can also opt-in on the tenant app "More" screen.  Please reply YES or START to enable.';

function optInGateEditorText(response) {
  const saved = response && String(response.body || '').trim();
  if (saved) return saved;
  const fallback = response && String(response.defaultBody || '').trim();
  return fallback || DEFAULT_OPT_IN_GATE_BODY;
}

module.exports = {
  DEFAULT_OPT_IN_GATE_BODY,
  BASIC_OPT_IN_GATE_BODY,
  optInGateEditorText,
};
